import { Button, Card, FormControl, Typography } from '@mui/material';
import styled from 'styled-components';

export const SectionTitle = styled(Typography)`
  margin-bottom: 32px;
  color: #616161;
  font-weight: bold;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ReportsLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;

  & > * {
    flex: 1 1 360px;
    max-width: 440px;
  }
`;

export const StyledCard = styled(Card)`
  border-color: transparent;

  & > *:last-child {
    margin-top: 16px;
  }
`;

export const ReportTitle = styled(Typography)`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 20px;
`;

export const ReportDescription = styled(Typography)`
  margin-bottom: 24px;
  color: #666;
  line-height: 1.5;
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  margin-bottom: 24px;
`;

export const OptionsToggle = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  cursor: pointer;

  svg {
    margin-left: 4px;
  }
`;

export const OptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormatLabel = styled(Typography)`
  color: #666;
`;

export const DatesWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export const BuildButton = styled(Button)`
  padding: 10px 24px;
  font-weight: bold;
  text-transform: none;
`;
